import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'payment-payable-amount-section',
  templateUrl: './payable-amount-section.component.html',
  styleUrls: ['./payable-amount-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayableAmountSectionComponent {
  @Input() subTotal: number;
  @Input() creditMemoSubTotal: number;
  @Input() currencyCode: string;
  @Input() surchargeFeeAmount: number;
  @Input() surchargeFeePercentage: number;
  @Input() surchargeFeeVisible: boolean;
  @Input() surchargeFeePercentageVisible: boolean;
  @Input() isDiscountAmountVisible: boolean;
  @Input() isZeroDollarPaymentEnabled: boolean;
  @Input() showCutOffMessaging: boolean;
  @Input() cutOffTime: Date;

  _totalAmount: number;
  get totalAmount(): number {
    if (this._totalAmount) {
      return this._totalAmount;
    }
    return this.subTotal;
  }

  @Input() set totalAmount(value: number) {
    this._totalAmount = value;
  }

  _discountAmountSubTotal: number;
  @Input() set discountAmountSubTotal(value: number) {
    this._discountAmountSubTotal = value ?? 0;
  }

  get discountAmountSubTotal(): number {
    return this._discountAmountSubTotal ?? 0;
  }
}
